// getIsPermissionMatched.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const defaultArray = [];

/*
 * Get is permission matched by remote config key
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} remoteConfigKey - remote config key.
 * @return {boolean|undefined} Return true if token scopes include required scope.
 */
export const getIsPermissionMatched = createCachedSelector(
  state => getMeData(state, 'tokenScopes'),
  (state, remoteConfigKey) => getRemoteConfigData(state, remoteConfigKey),
  (tokenScopes = defaultArray, scopes = defaultArray) => {
    if (!scopes.length || !tokenScopes.length) {
      return;
    }
    return scopes.some(scope =>
      tokenScopes.some(
        tokenScope => scope.toLowerCase() === tokenScope.toLowerCase()
      )
    );
  }
)((state, remoteConfigKey) => `${remoteConfigKey}`);

export default getIsPermissionMatched;
